import React from 'react';
import { Controller } from '../../svg/scholarships/Controller';

type Props = {
    className?: string;
    icon: JSX.Element;
    description: string;
    tagline: string;
};

export const OpporCard: React.FC<Props> = ({ className, tagline, description, icon }) => {
    return (
        <div className={`scholar-card${className ? ` ${className}` : ''}`}>
            <div className="gamer-icon-container">{icon}</div>
            <p className="card-description">{description}</p>
            <p className="card-tagline">{tagline}</p>
        </div>
    );
};
